"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AccessibleRoomTypeOptionsContainer;
var _api = require("@whitbread-eos/api");
var _nextI18next = require("next-i18next");
var _AccessibleRoomTypeOptions = _interopRequireDefault(require("./AccessibleRoomTypeOptions.component"));
var _jsxRuntime = require("react/jsx-runtime");
function AccessibleRoomTypeOptionsContainer(_ref) {
  var {
    data,
    accessibleRoomSelections,
    roomTypeSelections,
    onRoomTypeSelection,
    onAccessibleRoomSelection,
    hotelInventoryResponse,
    selectedPMSRoomTypes
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)(['common']);
  if (!data) return null;
  var rooms = [];
  var accessibleRooms = [];
  rooms = data.map(room => {
    accessibleRooms = room.rooms.map(roomInfo => {
      if (roomInfo !== null && roomInfo !== void 0 && roomInfo.specialRequests.includes('WETR') || roomInfo !== null && roomInfo !== void 0 && roomInfo.specialRequests.includes('LOWB')) return _api.ROOM_TYPE.STANDARD_ACCESSIBLE;else if (roomInfo !== null && roomInfo !== void 0 && roomInfo.specialRequests.includes('BFRE')) return _api.ROOM_TYPE.BARRIER_FREE;
    });
    return {
      roomTypes: Array.from(new Set(room.rooms.map(roomInfo => {
        return _api.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING[roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.pmsRoomType] ? t(_api.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING[roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.pmsRoomType]) : '';
      }))),
      adults: room.adults,
      children: room.children,
      accessibleRoomTypes: accessibleRooms.filter(item => item !== undefined).length > 0 ? accessibleRooms : undefined
    };
  });
  return (0, _jsxRuntime.jsx)(_AccessibleRoomTypeOptions.default, {
    rooms: rooms,
    roomTypeSelections: roomTypeSelections,
    accessibleRoomSelections: accessibleRoomSelections,
    onRoomTypeSelection: onRoomTypeSelection,
    onAccessibleRoomSelection: onAccessibleRoomSelection,
    hotelInventoryResponse: hotelInventoryResponse,
    selectedPMSRoomTypes: selectedPMSRoomTypes
  });
}